const nodesWithBlackAndWhiteEffect = Array.from(document.getElementsByClassName('black-and-white'));
const activeClass = 'black-and-white--active';
const activationThreshold = .9;

const handleIntersectionChanges = function (entries, observer) {
    entries.forEach(({ target, intersectionRatio }) => {
        if (intersectionRatio > activationThreshold) {
            target.classList.add(activeClass);
        } else {
            target.classList.remove(activeClass);
        }
    });
}

if (window.matchMedia('(pointer: none) or (pointer: coarse)').matches) {
    const observer = new IntersectionObserver(handleIntersectionChanges, {
        threshold: [1 - activationThreshold, 0 + activationThreshold],
    });
    nodesWithBlackAndWhiteEffect.forEach(node => observer.observe(node))
}
